
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    school: '',
    grade: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSubmit.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3kog0vkcuem1abd8hlg', {
        method: 'POST',
        body: new URLSearchParams(formDataToSubmit as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          school: '',
          grade: '',
          email: '',
          message: ''
        });
        setTimeout(() => {
          setIsModalOpen(false);
          setSubmitStatus('');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-indigo-100 overflow-hidden">
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/e9200c91cf028cd1fbed25cc553f1f3b.jpg')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <div className="mb-8">
              <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
                세계인재교육사
              </h1>
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight">
              행복은 복잡한 것이 아닙니다
            </h2>
            
            <p className="text-lg md:text-xl lg:text-2xl mb-10 max-w-4xl mx-auto leading-relaxed">
              복잡하면 이미 행복이 아닙니다.<br />
              <span className="block mt-4 text-white/90">행복하지 않다면 본 프로그램에 참여하여</span>
              <span className="block font-bold text-orange-400 mt-3 text-xl md:text-2xl bg-black/30 px-4 py-2 rounded-lg backdrop-blur-sm border border-orange-400/30">
                🔑 행복의 열쇠를 찾아보세요!
              </span>
            </p>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-10 max-w-4xl mx-auto">
              <h3 className="text-xl md:text-2xl font-bold mb-6 text-yellow-300">
                특히 중학생·고등학생이 참여하면
              </h3>
              <p className="text-base md:text-lg mb-6 leading-relaxed">
                뛰어난 능력과 리더십, 솔로몬 같은 지혜를 얻을 수 있습니다
              </p>
              <div className="flex flex-wrap justify-center gap-3 text-sm">
                <span className="bg-blue-500/20 px-4 py-2 rounded-full">매주 철학 자료 제공</span>
                <span className="bg-green-500/20 px-4 py-2 rounded-full">자기개발 프로그램</span>
                <span className="bg-purple-500/20 px-4 py-2 rounded-full">지혜와 리더십 개발</span>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-user-add-line mr-2"></i>
                지금 회원가입하기
              </button>
              <div className="text-center">
                <p className="text-lg font-semibold text-yellow-300">월 회비 2,990원</p>
                <p className="text-sm opacity-90">매주 새로운 철학 자료 제공</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center">
          <div className="mb-8">
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
              세계인재교육사
            </h1>
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight">
            행복은 복잡한 것이 아닙니다
          </h2>
          
          <p className="text-lg md:text-xl lg:text-2xl mb-10 max-w-4xl mx-auto leading-relaxed">
            복잡하면 이미 행복이 아닙니다.<br />
            <span className="block mt-4">행복하지 않다면 본 프로그램에 참여하여</span>
            <span className="block font-semibold text-orange-400 mt-2">행복의 열쇠를 찾아보세요!</span>
          </p>
          
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/payment"
              className="inline-flex items-center px-8 py-4 border border-transparent text-base font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-secure-payment-line mr-2"></i>
              회비 결제
            </Link>
            <Link
              to="/admin"
              className="inline-flex items-center px-8 py-4 border border-gray-300 text-base font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-admin-line mr-2"></i>
              관리자
            </Link>
          </div>
        </div>
      </div>

      {/* Registration Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">회원가입</h3>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              <form onSubmit={handleSubmit} data-readdy-form id="registration-form">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      이름 *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="이름을 입력하세요"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      연락처 *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="010-0000-0000"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      학교명 *
                    </label>
                    <input
                      type="text"
                      name="school"
                      value={formData.school}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="학교명을 입력하세요"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      학년 *
                    </label>
                    <div className="relative">
                      <select
                        name="grade"
                        value={formData.grade}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm appearance-none cursor-pointer"
                      >
                        <option value="">학년을 선택하세요</option>
                        <option value="중1">중학교 1학년</option>
                        <option value="중2">중학교 2학년</option>
                        <option value="중3">중학교 3학년</option>
                        <option value="고1">고등학교 1학년</option>
                        <option value="고2">고등학교 2학년</option>
                        <option value="고3">고등학교 3학년</option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      이메일
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      placeholder="이메일을 입력하세요"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      참여 동기 및 기대사항
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                      placeholder="철학 공부에 대한 기대사항을 적어주세요 (최대 500자)"
                    />
                    <p className="text-xs text-gray-5 mt-1">{formData.message.length}/500자</p>
                  </div>
                </div>

                {submitStatus === 'success' && (
                  <div className="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded-lg text-sm">
                    회원가입이 완료되었습니다! 곧 연락드리겠습니다.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm">
                    오류가 발생했습니다. 다시 시도해주세요.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full mt-6 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white py-3 rounded-lg font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      처리중...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line mr-2"></i>
                      회원가입 신청
                    </>
                  )}
                </button>

                <p className="text-xs text-gray-500 mt-4 text-center">
                  회원가입 후 월 회비 2,990원으로 매주 철학 자료를 받아보실 수 있습니다.
                </p>
              </form>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
